module.exports = __webpack_public_path__ + "img/logo.06e73c8e.png";